import Container from "react-bootstrap/Container";
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";
import MovieProx from "../assets/Movieprox1.png";
import Muggle from "../assets/muggle.png";

import tract from "../assets/Tract1.png";
import logo_neu from "../assets/logo_neu.svg";
import React, { useState, useEffect } from "react";

import Link from "@mui/material/Link";
import ArrowForwardIosIcon from "@mui/icons-material/ArrowForwardIos";
import KeyboardArrowRightIcon from "@mui/icons-material/KeyboardArrowRight";
import Astria from "../assets/AstriaTodoAI.png";
import Joi from "../assets/Joi.webp";
import Joiai from "../assets/Joiai.png";
import Joiai2 from "../assets/Joiai2.png";
import baar from "../assets/baar.png";
import alum from "../assets/alum.png";
import alum1 from "../assets/alum1.png";
import die1 from "../assets/die1.png";
import die2 from "../assets/die2.png";

import Huskyhub from "../assets/Huskyhub.png";
import neu from "../assets/logo_husky.ico";
import ProjectItem from "./ProjectItem";
import TechStack from "./TechStack";
const Researches = () => {
  const [textProgress, setTextProgress] = useState(0);
  const loadingTexts = [
    // "👋 Hi, there! I am an aspiring software developer who enjoys discovering new ideas and technologies while diving.",
    // "Currently I am pursuing my Masters in Information Systems at Northeastern University, interning at TRACT as a software development intern.",
    // "I am a full-stack developer specializing in MERN stack Front-end and Back-end jobs. I am looking for an intern position this year or a new grad job in 2024. Please feel free to get in touch with me on LinkedIn or via email."
    "Researches",
  ];

  useEffect(() => {
    const totalTextLength = loadingTexts.reduce(
      (total, text) => total + text.length,
      0
    );
    const increment = 1;

    const timer = setInterval(() => {
      setTextProgress((prevProgress) => prevProgress + increment);
    }, 100);

    if (textProgress >= totalTextLength) {
      clearInterval(timer);
    }

    return () => {
      clearInterval(timer);
    };
  }, []);

  const projectsData = [
    {
      title: "Aluminum Electrolytic Anode Slot Structure Optimization",
      images: [alum1, alum],
      imageLink: "",
      about:"Research on the influence of anode structure to the electrolytic reaction",
      
    //   `Goal: "Research on the influence of anode structure to the electrolytic reaction",
    //   Principles:
    //     "2Al (s) + 6HCl (aq) → 2AlCl 3(aq) + 3 H2 (g)Aluminum Electrolytic",
    //   Hypothesis:
    //     "The process of Al electrolytic can be optimized to an ideal state with a balanced combination of key parameters including pole pitch, slot width, slot number and inclination angle.",
    //   Method: "Ansys simulation + experiment",
    //   Observation: "The generation rate and uniformity of H2 gas",`

      //   breadcrumbs: [
      //     <Link
      //       underline="hover"
      //       key="1"
      //       color="inherit"
      //       href="https://baarmoto.vercel.app/"
      //       style={{ marginRight: "10px" }}
      //     >
      //       <span className="boldsub">
      //         <KeyboardArrowRightIcon xs={{ fontSize: "small", color: "red" }} />
      //         SEE PROJECT
      //       </span>
      //     </Link>,
      //   ],
    },
    {
      title: "Die Casting Mold CAD - thesis project ",
      images: [die1, die2],
      imageLink: "",
      about:
        "Analyzing the mold clamping mechanism of the J1163C die-casting machine",
      Calculation: "clamping force and deformation",

      Position: "SolidWorks modeling and AutoCAD for component drawings",
    },
  ];

  return (
    <section className="">
      <Container className="p-4">
        <Row className="align-items-center">
          <Col lg={10} md={10}>
            {loadingTexts.map((text, index) => (
              <h1 className="name py-0" style={{ textAlign: "left" }}>
                <ArrowForwardIosIcon xs={{ fontSize: "large" }} />{" "}
                {text.substring(0, textProgress)}
              </h1>
            ))}
            <div style={{ marginTop: 100 }}>
              {projectsData.map((project, index) => (
                <ProjectItem
                  key={index}
                  title={project.title}
                  images={project.images}
                  imageLink={project.imageLink}
                  about={project.about}
                  techs={project.techs}
                  position={project.position}
                  breadcrumbs={project.breadcrumbs}
                />
              ))}
            </div>
          </Col>

          {/* Whole Body Border*/}

        </Row>
      </Container>
    </section>
  );
};

export default Researches;
